import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { helper } from '@ember/component/helper';
import Icon from 'marcemira/components/icon';

const yearsOfExperience = helper(() => {
  const startYear = 1986 + 13;
  const currentYear = new Date().getFullYear();
  return currentYear - startYear;
});

const yearsWithForeignClients = helper(() => {
  const startYear = 2015;
  const currentYear = new Date().getFullYear();
  return currentYear - startYear;
});

  <template>
    {{pageTitle "About - Marcemira"}}

    <section id="about" aria-label="About Marcelo Mira">

    <h1 class="title">{{{t "about.title"}}}</h1>

    <article class="about-me">
      <figure class="profile"></figure>
      <p>
        {{{t "about.intro" years=(yearsOfExperience)}}}
      </p>
      <p>
        {{{t "about.intro2"}}}
      </p>
    </article>

    <div class="my-12"></div>

    <div class="clearfix"></div>

    <div class="dp-separator"></div>

      <section id="resume" class="text-center" aria-label="Professional resume">

      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-4">
          <article>
            <h2>
              <span class="hidden-xs">{{t "about.personal"}}</span>
              <span class="visible-xs-inline-block">{{t "about.personal-xs"}}</span>
            </h2>
            <dl>
              <div class="flex mb-2">
                <dt class="w-1/3 sm:w-2/5 text-left font-semibold pr-2">{{t "about.personal-name"}}</dt>
                <dd class="w-2/3 sm:w-3/5 text-left ml-0">Marcelo Ariel Mira Marin</dd>
              </div>
              <div class="flex mb-2">
                <dt class="w-1/3 sm:w-2/5 text-left font-semibold pr-2">{{t "about.personal-birth"}}</dt>
                <dd class="w-2/3 sm:w-3/5 text-left ml-0">{{t "about.personal-birth-val"}}</dd>
              </div>
              <div class="flex mb-2">
                <dt class="w-1/3 sm:w-2/5 text-left font-semibold pr-2">{{t "about.personal-lives"}}</dt>
                <dd class="w-2/3 sm:w-3/5 text-left ml-0">Córdoba, Argentina</dd>
              </div>
              <div class="flex mb-2">
                <dt class="w-1/3 sm:w-2/5 text-left font-semibold pr-2">{{t "about.personal-activity"}}</dt>
                <dd class="w-2/3 sm:w-3/5 text-left ml-0">{{t "about.personal-activity-val"}}</dd>
              </div>
              <div class="flex mb-2">
                <dt class="w-1/3 sm:w-2/5 text-left font-semibold pr-2">Email</dt>
                <dd class="w-2/3 sm:w-3/5 text-left ml-0"><a href="mailto:hello@marcemira.com">hello@marcemira.com</a></dd>
              </div>
            </dl>
          </article>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-4">
          <article class="tags">
            <h2>
              <span class="hidden-xs">{{t "about.technologies"}}</span>
              <span class="visible-xs-inline-block">{{t "about.technologies-xs"}}</span>
            </h2>
            <div class="flex flex-wrap justify-center gap-2 max-w-md mx-auto">
              {{#each @model.technologies as |tech|}}
                <span class="label rounded-full">
                  {{tech}}
                </span>
              {{/each}}
            </div>
            <div class="clearfix"></div>
          </article>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-4">
          <article>
            <h2>{{t "about.knowledges"}}</h2>
            <dl>
              {{#each @model.knowledges as |knowledge|}}
                <div class="flex mb-2">
                  <dt class="w-2/5 text-left font-semibold pr-2">{{t knowledge.labelKey}}</dt>
                  <dd class="w-3/5 text-left ml-0">{{t knowledge.valueKey}}</dd>
                </div>
              {{/each}}
            </dl>
          </article>
        </div>
      </div>

      </section>

      <div class="dp-separator"></div>

        <article id="specialties" aria-label="Professional specialties">

          <h2 class="w-full mb-7 mt-0">{{t "about.specialties"}}</h2>

          <div class="max-w-5xl mx-auto">
            <section class="flex items-start mb-10 px-5">
              <div class="flex-shrink-0 mr-4">
                <Icon @name="globe-alt" class="w-8 h-8 text-blue-600 dark:text-blue-400" />
              </div>
              <div class="flex-1">
                <h3 class="font-semibold text-xl mb-3">{{t "about.specialty1-title"}}</h3>
                <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.specialty1-desc"}}</p>
              </div>
            </section>

            <section class="flex items-start mb-10 px-5">
              <div class="flex-shrink-0 mr-4">
                <Icon @name="code-bracket" class="w-8 h-8 text-blue-600 dark:text-blue-400" />
              </div>
              <div class="flex-1">
                <h3 class="font-semibold text-xl mb-3">{{t "about.specialty2-title"}}</h3>
                <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.specialty2-desc"}}</p>
              </div>
            </section>

            <section class="flex items-start mb-10 px-5">
              <div class="flex-shrink-0 mr-4">
                <Icon @name="sparkles" class="w-8 h-8 text-blue-600 dark:text-blue-400" />
              </div>
              <div class="flex-1">
                <h3 class="font-semibold text-xl mb-3">{{t "about.specialty3-title"}}</h3>
                <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.specialty3-desc"}}</p>
              </div>
            </section>

            <section class="flex items-start mb-10 px-5">
              <div class="flex-shrink-0 mr-4">
                <Icon @name="light-bulb" class="w-8 h-8 text-blue-600 dark:text-blue-400" />
              </div>
              <div class="flex-1">
                <h3 class="font-semibold text-xl mb-3">{{t "about.specialty4-title"}}</h3>
                <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.specialty4-desc"}}</p>
              </div>
            </section>

            <section class="flex items-start mb-10 px-5">
              <div class="flex-shrink-0 mr-4">
                <Icon @name="users" class="w-8 h-8 text-blue-600 dark:text-blue-400" />
              </div>
              <div class="flex-1">
                <h3 class="font-semibold text-xl mb-3">{{t "about.specialty5-title"}}</h3>
                <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.specialty5-desc"}}</p>
              </div>
            </section>
          </div>

        </article>

        <div class="dp-separator"></div>

        <article id="philosophy" aria-label="Work philosophy">

          <h2 class="w-full mb-7 mt-0">{{t "about.philosophy"}}</h2>

          <div class="max-w-5xl mx-auto">
            <section class="w-full px-5 mb-10">
              <p class="text-left text-lg mb-6">{{{t "about.philosophy-intro"}}}</p>
            </section>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-8 px-5">
              <section class="flex items-start">
                <div class="flex-shrink-0 mr-4">
                  <Icon @name="user-circle" class="w-7 h-7 text-green-600 dark:text-green-400" />
                </div>
                <div class="flex-1">
                  <h3 class="font-semibold text-lg mb-2">{{t "about.philosophy1-title"}}</h3>
                  <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.philosophy1-desc"}}</p>
                </div>
              </section>

              <section class="flex items-start">
                <div class="flex-shrink-0 mr-4">
                  <Icon @name="code-bracket" class="w-7 h-7 text-green-600 dark:text-green-400" />
                </div>
                <div class="flex-1">
                  <h3 class="font-semibold text-lg mb-2">{{t "about.philosophy2-title"}}</h3>
                  <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.philosophy2-desc"}}</p>
                </div>
              </section>

              <section class="flex items-start">
                <div class="flex-shrink-0 mr-4">
                  <Icon @name="rocket-launch" class="w-7 h-7 text-green-600 dark:text-green-400" />
                </div>
                <div class="flex-1">
                  <h3 class="font-semibold text-lg mb-2">{{t "about.philosophy3-title"}}</h3>
                  <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.philosophy3-desc"}}</p>
                </div>
              </section>

              <section class="flex items-start">
                <div class="flex-shrink-0 mr-4">
                  <Icon @name="users" class="w-7 h-7 text-green-600 dark:text-green-400" />
                </div>
                <div class="flex-1">
                  <h3 class="font-semibold text-lg mb-2">{{t "about.philosophy4-title"}}</h3>
                  <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.philosophy4-desc"}}</p>
                </div>
              </section>

              <section class="flex items-start md:col-span-2">
                <div class="flex-shrink-0 mr-4">
                  <Icon @name="trophy" class="w-7 h-7 text-green-600 dark:text-green-400" />
                </div>
                <div class="flex-1">
                  <h3 class="font-semibold text-lg mb-2">{{t "about.philosophy5-title"}}</h3>
                  <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.philosophy5-desc"}}</p>
                </div>
              </section>
            </div>
          </div>

        </article>

        <div class="dp-separator"></div>

        <article id="highlights" aria-label="Experience highlights">

          <h2 class="w-full mb-7 mt-0">{{t "about.highlights"}}</h2>

          <div class="max-w-5xl mx-auto">
            <section class="flex items-start mb-10 px-5">
              <div class="flex-shrink-0 mr-4">
                <Icon @name="rocket-launch" class="w-8 h-8 text-purple-600 dark:text-purple-400" />
              </div>
              <div class="flex-1">
                <h3 class="font-semibold text-xl mb-3">{{t "about.highlight1-title" years=(yearsOfExperience)}}</h3>
                <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.highlight1-desc"}}</p>
              </div>
            </section>

            <section class="flex items-start mb-10 px-5">
              <div class="flex-shrink-0 mr-4">
                <Icon @name="globe-alt" class="w-8 h-8 text-purple-600 dark:text-purple-400" />
              </div>
              <div class="flex-1">
                <h3 class="font-semibold text-xl mb-3">{{t "about.highlight2-title" foreignYears=(yearsWithForeignClients)}}</h3>
                <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.highlight2-desc" foreignYears=(yearsWithForeignClients)}}</p>
              </div>
            </section>

            <section class="flex items-start mb-10 px-5">
              <div class="flex-shrink-0 mr-4">
                <Icon @name="briefcase" class="w-8 h-8 text-purple-600 dark:text-purple-400" />
              </div>
              <div class="flex-1">
                <h3 class="font-semibold text-xl mb-3">{{t "about.highlight3-title"}}</h3>
                <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.highlight3-desc"}}</p>
              </div>
            </section>

            <section class="flex items-start mb-10 px-5">
              <div class="flex-shrink-0 mr-4">
                <Icon @name="light-bulb" class="w-8 h-8 text-purple-600 dark:text-purple-400" />
              </div>
              <div class="flex-1">
                <h3 class="font-semibold text-xl mb-3">{{t "about.highlight4-title"}}</h3>
                <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.highlight4-desc"}}</p>
              </div>
            </section>

            <section class="flex items-start mb-10 px-5">
              <div class="flex-shrink-0 mr-4">
                <Icon @name="trophy" class="w-8 h-8 text-purple-600 dark:text-purple-400" />
              </div>
              <div class="flex-1">
                <h3 class="font-semibold text-xl mb-3">{{t "about.highlight5-title"}}</h3>
                <p class="text-base text-gray-700 dark:text-gray-300">{{t "about.highlight5-desc"}}</p>
              </div>
            </section>
          </div>

        </article>

      <div class="dp-separator"></div>

        <article class="exp w-full" aria-label="Professional work experience">
          <h2 class="w-full text-center mb-7 mt-0">{{t "about.px"}}</h2>
          <div class="flex flex-wrap -mx-4 max-w-6xl mx-auto mt-5">
            {{#each @model.workExperiences as |exp|}}
              <div class="w-full px-4 md:w-1/2 mb-5 min-h-[130px]">
                <h4 class="mb-2">
                  <strong>{{#if exp.companyKey}}{{t exp.companyKey}}{{else}}{{exp.company}}{{/if}}</strong>
                  <small class="text-xs ml-1">
                    <span>{{exp.startDate}}</span> - <span>{{#if exp.endDate}}{{exp.endDate}}{{else}}{{t "about.px-today"}}{{/if}}</span>
                  </small>
                </h4>
                <div class="flex mb-1">
                  <i class="w-1/8 text-right pr-2 italic">{{t "about.px-roles"}}:</i>
                  <span class="w-4/5 text-left">{{#if exp.rolesKey}}{{t exp.rolesKey}}{{else}}{{exp.roles}}{{/if}}</span>
                </div>
                <div class="flex">
                  <i class="w-1/8 text-right pr-2 italic">{{t "about.px-detail"}}:</i>
                  <span class="w-4/5 text-left">{{#if exp.descriptionKey}}{{t exp.descriptionKey}}{{else}}{{exp.description}}{{/if}}</span>
                </div>
              </div>
            {{/each}}
          </div>
        </article>

        <div class="dp-separator"></div>

        <article aria-label="Contact information">
          <h2 class="w-full text-center mb-7 mt-0">{{t "about.contact"}}</h2>

          <ul id="social" class="flex flex-wrap justify-center items-center" aria-label="Social media links" role="list">
        <li>
          <a
            href="https://www.linkedin.com/in/marcemira"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn profile for Marcelo Mira"
          >
            linkedin.com/in/marcemira
          </a>
        </li>
        <li>
          <a
            href="https://github.com/marcemira"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub profile for Marcelo Mira"
          >
            github.com/marcemira
          </a>
        </li>
          </ul>

          <div class="dp-separator"></div>

          <h2 class="w-full text-center mt-0">{{t "about.email"}} <a href="mailto:hello@marcemira.com">hello@marcemira.com</a></h2>
        </article>

        <div class="dp-separator"></div>

        <div class="max-w-4xl mx-auto text-center px-5 mb-12">
          <p class="text-lg">
            {{t "about.cta"}}
          </p>
        </div>

        <div class="bottom"></div>

    </section>
</template>
